// extracted by mini-css-extract-plugin
export default {"smartContentSwitch":"style_smartContentSwitch__Xe6Ns"};